import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getPatronsByPatronIds } from '../../services/artifactService'
import useNotifications from '../useNotifications'

const useArtifactEventsPatrons = (patronIds, shouldExecute) => {
  const { t } = useTranslation()
  const [artifactEventsPatrons, setArtifactEventsPatrons] = useState(null)
  const { error } = useNotifications()

  useEffect(() => {
    if (shouldExecute) {
      const patronIdSet = new Set()
      patronIds.forEach((patronId) => {
        if (patronId !== -2 && patronId !== 0) patronIdSet.add(patronId)
      })
      let patronIdsParam = ''
      patronIdSet.forEach((patronId) => {
        patronIdsParam = `${patronIdsParam + patronId},`
      })
      if (patronIdsParam !== '') {
        const params = {
          patronIds: patronIdsParam.slice(0, -1),
        }
        getPatronsByPatronIds(params)
          .then((response) => {
            setArtifactEventsPatrons(response.data)
          })
          .catch((err) => {
            error(
              t('hooks.errors.retrievingPatronsForArtifactEvents', `Error retrieving patrons for artifact events`),
              err
            )
          })
      }
    }
  }, [error, patronIds, shouldExecute, t])

  return {
    artifactEventsPatrons,
  }
}

export default useArtifactEventsPatrons
